import React from 'react';
import { Switch } from 'react-router-dom';

import { useAuth } from '~/context/AuthContext';
import { MENU_OBJECT } from '~/utils/menuItems';
import Route from './Route';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import Products from '../pages/Products';
import IfoodRelation from '../pages/IfoodRelation';
import FiscalRelation from '../pages/FiscalPage/FiscalRelation';
import EanCodeRelation from '../pages/EanCodeRelation';
import N99FoodRelation from '../pages/99foodRelation';
import Operation from '../pages/Operation';
import Orders from '../pages/Orders';
import Kds from '../pages/Kds';
import Kitchen from '../pages/Kds/Kitchen';
import PasswordPickup from '../pages/Kds/PasswordPickup';
import Transfers from '../pages/Transfers';
import BalconyPage from '../pages/BalconyPage';
import BalancePage from '../pages/BalancePage';
import Suppliers from '../pages/Financial/Suppliers';
import Transactions from '../pages/Financial/Transactions';
import CashManagementPage from '../pages/Financial/CashManagementPage';
import RegistersPage from '../pages/RegistersPage';
import CreateTables from '../pages/RegistersPage/Tables/Create';
import EditTables from '../pages/RegistersPage/Tables/Edit';
import ViewTables from '../pages/RegistersPage/Tables/View';
import EditWaiter from '../pages/RegistersPage/Waiter/Edit';
import Inputs from '../pages/Inputs';
import Markup from '../pages/Markup';
import DeliveryConfig from '../pages/Delivery/Config';
import DeliveryAddresses from '../pages/Delivery/Addresses';
import Scheduling from '../pages/Delivery/Scheduling';
import Tickets from '../pages/Delivery/Coupons';
import DeliveryOrdersPage from '../pages/Delivery/DeliveryOrdersPage';
import OpeningHours from '../pages/Delivery/OpeningHours';
import Motoboy from '../pages/Motoboys';
import ViewDeliveryBills from '../pages/DeliveryBills/View';
import Settings from '../pages/Settings';
import EditPrinter from '../pages/Settings/EditPrinter';
import Help from '../pages/Help';
import SearchPage from '../pages/SearchPage';
import ViewBills from '../pages/Bills/View';
import ProfilePage from '../pages/ProfilePage';
import SignIn from '../pages/SignIn';
import LoginByToken from '~/pages/LoginByToken';
import CreditRegister from '../pages/Financial/CreditRegister';
import FiscalGroups from '../pages/FiscalPage/FiscalGroups';
import FiscalPage from '../pages/FiscalPage';
import NotaAvulsa from '../pages/FiscalPage/NotaAvulsa';
import NfeManifestInfo from '~/pages/FiscalPage/NfeManifestInfo';
import TransferInputs from '~/pages/FiscalPage/TransferInputs';
import EditMotoboy from '../pages/Motoboys/Edit';
import PrintNFePage from '../pages/PrintNFePage';

export default function Routes() {
  const { user, signOut } = useAuth();

  return (
    <Switch>
        {/* Autenticação */}
        <Route path="/" exact component={SignIn} />
        <Route path="/login-by-token" component={LoginByToken} />

        {/* Perfil */}
        <Route path="/profile/info" component={ProfilePage} isPrivate />
        <Route path="/profile/tasks" exact component={ProfilePage} isPrivate />
        <Route
          path="/profile/user-profile"
          exact
          component={ProfilePage}
          isPrivate
        />

        {/* Operação */}
        <Route path="/operation" exact component={Operation} isPrivate />
        <Route path="/operation/kds" component={Kds} isPrivate />
        <Route path="/operation/bills" component={ViewBills} isPrivate />
        <Route
          path="/operation/transactions"
          component={Transactions}
          isPrivate
        />
        <Route
          path="/operation/audit-box"
          component={CashManagementPage}
          isPrivate
        />
        <Route
          path="/operation/opening-box"
          component={CashManagementPage}
          exact
          isPrivate
        />
        <Route
          path="/operation/cashier"
          component={CashManagementPage}
          isPrivate
        />

        {/* Fiscal */}
        <Route path="/fiscal/groups" component={FiscalGroups} isPrivate />
        <Route
          path="/fiscal/manifest/info"
          component={NfeManifestInfo}
          isPrivate
        />
        <Route path="/fiscal/manifest" component={FiscalPage} isPrivate />
        <Route path="/fiscal/entries" component={FiscalPage} isPrivate />
        <Route path="/fiscal/returned" component={FiscalPage} isPrivate />
        <Route path="/fiscal/issued" component={FiscalPage} isPrivate />
        <Route path="/fiscal/nfe-avulsa" component={NotaAvulsa} isPrivate />
        <Route path="/print-nfce/:ref" component={PrintNFePage} isPrivate />

        {/* Cadastros */}
        <Route path="/register/menu" exact component={Products} isPrivate />
        <Route path="/register/ifood" component={IfoodRelation} isPrivate />
        <Route path="/register/99food" component={N99FoodRelation} isPrivate />
        <Route path="/register/fiscal" component={FiscalRelation} isPrivate />
        <Route
          path="/register/ean-code-relation"
          component={EanCodeRelation}
          isPrivate
        />
        <Route path="/register/printers" exact component={Settings} isPrivate />
        <Route
          path="/register/printers/edit"
          component={EditPrinter}
          isPrivate
        />
        <Route path="/register/stock" exact component={Inputs} isPrivate />
        <Route
          path="/register/stock/transfers"
          component={TransferInputs}
          isPrivate
        />
        <Route
          path="/register/stock/suppliers"
          component={Suppliers}
          isPrivate
        />
        <Route path="/register/markup" component={Markup} isPrivate />
        <Route path="/register/tables/new" component={CreateTables} isPrivate />
        <Route path="/register/tables/edit" component={EditTables} isPrivate />
        <Route path="/register/tables/view" component={ViewTables} isPrivate />
        <Route
          path="/register/waiters"
          exact
          component={RegistersPage}
          isPrivate
        />
        <Route
          path="/register/waiters/edit"
          exact
          component={EditWaiter}
          isPrivate
        />
        <Route
          path="/register/users"
          exact
          component={RegistersPage}
          isPrivate
        />
        <Route
          path="/register/tables"
          exact
          component={RegistersPage}
          isPrivate
        />
        <Route
          path="/register/stone-devices"
          exact
          component={RegistersPage}
          isPrivate
        />
        <Route
          path="/register/balances"
          exact
          component={RegistersPage}
          isPrivate
        />
        <Route
          path="/register/credit-register"
          component={CreditRegister}
          isPrivate
        />
        <Route
          path="/register/transfer-items"
          component={Transfers}
          isPrivate
        />

        {/* Delivery */}
        <Route
          path="/delivery/orders"
          exact
          component={DeliveryOrdersPage}
          isPrivate
        />
        <Route
          path="/delivery/config"
          exact
          component={DeliveryConfig}
          isPrivate
        />
        <Route path="/delivery/motoboys" exact component={Motoboy} isPrivate />
        <Route
          path="/delivery/opening-hours"
          exact
          component={OpeningHours}
          isPrivate
        />
        <Route
          path="/delivery/motoboys/edit"
          exact
          component={EditMotoboy}
          isPrivate
        />
        <Route
          path="/delivery/addresses"
          exact
          component={DeliveryAddresses}
          isPrivate
        />
        <Route path="/delivery/coupons" component={Tickets} isPrivate />
        <Route
          path="/delivery/scheduling"
          exact
          component={Scheduling}
          isPrivate
        />
        <Route path="/delivery/bills" component={ViewDeliveryBills} isPrivate />
        <Route
          path="/delivery/opening-box"
          component={() => <Redirect to="/operation/opening-box" />}
          exact
          isPrivate
        />

        {/* Outros */}
        <Route path="/orders" component={Orders} isPrivate />
        <Route path="/balcony" exact component={BalconyPage} isPrivate />
        <Route path="/drive-thru" exact component={BalconyPage} isPrivate />
        <Route path="/balance" exact component={BalancePage} isPrivate />
        <Route path="/kitchen" component={Kitchen} isPrivate />
        <Route path="/kds-password" component={PasswordPickup} isPrivate />
        <Route path="/help" component={Help} isPrivate />
        <Route
          path="/search"
          component={() => (
            <SearchPage menuItems={MENU_OBJECT(user, signOut).categories} />
          )}
          isPrivate
        />
    </Switch>
  );
}
